/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePromotionDto
 */
export interface CreatePromotionDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionDto
     */
    type: CreatePromotionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionDto
     */
    nameEn: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionDto
     */
    nameAr: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionDto
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreatePromotionDto
     */
    endsAt?: Date;
}


/**
 * @export
 */
export const CreatePromotionDtoTypeEnum = {
    DeliveryFeeWaiver: 'DELIVERY_FEE_WAIVER'
} as const;
export type CreatePromotionDtoTypeEnum = typeof CreatePromotionDtoTypeEnum[keyof typeof CreatePromotionDtoTypeEnum];


/**
 * Check if a given object implements the CreatePromotionDto interface.
 */
export function instanceOfCreatePromotionDto(value: object): value is CreatePromotionDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    return true;
}

export function CreatePromotionDtoFromJSON(json: any): CreatePromotionDto {
    return CreatePromotionDtoFromJSONTyped(json, false);
}

export function CreatePromotionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromotionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'],
        'active': json['active'] == null ? undefined : json['active'],
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
    };
}

export function CreatePromotionDtoToJSON(value?: CreatePromotionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'active': value['active'],
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt'] as any).toISOString()),
    };
}

